import * as React from 'react';
import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { INotificationRow } from 'core/hooks';
import { relativeTime, TNotificationLocale } from 'core/utils/notificationTime';

import * as S from './NotificationCenter.styled';
import { kindMeta } from './notificationTypes';

interface IProps {
  row: INotificationRow;
  onOpen: (row: INotificationRow) => void;
}

/**
 * Одна строка ленты (ТЗ 0068): иконка вида · тип события · название задачи ·
 * относительное время. Читается сканированием, а не чтением, поэтому тело
 * жёстко обрезано двумя строками — иначе одна длинная задача ломает ритм
 * всего списка.
 */
export const NotificationRow = memo(({ row, onOpen }: IProps) => {
  const { t, i18n } = useTranslation();
  const meta = kindMeta(row.kind);
  const Icon = meta.icon;
  const unread = !row.readAt;
  const locale: TNotificationLocale = i18n.language === 'pl' ? 'pl' : 'ru';

  return (
    <S.Row type="button" $unread={unread} onClick={() => onOpen(row)}>
      <S.RowIcon $tone={meta.tone}>
        <Icon size={18} />
      </S.RowIcon>
      <S.RowBody>
        <S.RowTitle>{t(meta.labelKey)}</S.RowTitle>
        <S.RowText>
          {row.title}
          {row.body ? ` — ${row.body}` : ''}
        </S.RowText>
      </S.RowBody>
      <S.RowTime>{relativeTime(row.createdAt, locale)}</S.RowTime>
    </S.Row>
  );
});

NotificationRow.displayName = 'NotificationRow';
